import { Icon } from "element-react"
import React, { ReactElement } from "react"

interface IconBoxProps {
    classNames?: string
    icon: ReactElement<Icon>
}

export const IconBox = ({ icon, classNames }: IconBoxProps) => (
    <span className={`inline-block w-24 h-24 rounded-sm ${classNames ?? ""}`}>
        <div className="flex items-center justify-center w-full h-full">{icon}</div>
    </span>
)
